let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jXrdN")).then(() => parcelRequire('25bHO'));